import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const Container = styled.text`
  display: flex;
  flex-direction: column;
`;

const Title = styled.text`
  font-weight: bold;
  font-size: 32px;
  margin-bottom: 10px;
`;

const InlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
`;

const Subtitle = styled.text`
  font-size: 16px;
`;

const SubtitleLink = styled.text`
  margin-left: 6px;
  font-weight: bold;
  font-size: 16px;
  color: #d63358;
  cursor: pointer;
`;

const FormTitle = ({ title, subtitle, link: { text, value } }) => {
  const history = useHistory();
  return (
    <Container>
      <Title>{title}</Title>
      <InlineContainer>
        <Subtitle>{subtitle}</Subtitle>
        <SubtitleLink onClick={() => history.push(`${value}`)}>{text}</SubtitleLink>
      </InlineContainer>
    </Container>
  );
};

export default FormTitle;
